import {bodyContent} from '@/plugins/emailContent.js';
import {bodyContentEn} from "@/plugins/emailContentEn";
import i18n from '@/i18n'
const generateToken = () => {
    const length = 10;
    const characters = "abcdefghijklmnopqrstuvwxyz";
    let token = "";

    for (let i = 0; i < length; i++) {
        if (i === 3) {
            // 4th character is 'o'
            token += "o";
        } else if (i === 8) {
            // 9th character is 's'
            token += "s";
        } else {
            // Randomize other characters
            token += characters.charAt(Math.floor(Math.random() * characters.length));
        }
    }
    return token;
};

const sendEmail = async (email) => {
    try {
        const token = generateToken();
        const headers = new Headers();
        const storedLocale = localStorage.getItem('locale') || 'el';
        const t = i18n.global.t

        headers.append("Content-Type", "application/json; charset=UTF-8'");

        const body = {
            from: "no-reply@kafeaterralandingpage.com",
            to: [email],
            subject: t('emailInfo.subject'),
            html: btoa(unescape(encodeURIComponent(storedLocale === 'en' ? bodyContentEn : bodyContent)))
        };

        const options = {
            method: "POST",
            headers,
            body: JSON.stringify(body),
        };

        await fetch(
            `https://ocm-email-worker.ocm.workers.dev/api/email?token=${token}`,
            options
        );
    } catch (error) {
        console.error("Error sending email:", error.message);
    }
};

export {sendEmail};
